import { useEffect, useRef, useState } from 'react';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

const DASHBOARD_PATHS = ['/', '/admin', '/farmer', '/butcher', '/customer'];

export default function BackExitGuard() {
  const [showToast, setShowToast] = useState(false);
  const confirmingRef = useRef(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let listenerHandle;

    App.addListener('backButton', ({ canGoBack }) => {
      const currentPath = window.location.pathname;
      const isInDashboard = DASHBOARD_PATHS.some(p =>
        p === '/' ? currentPath === '/' : currentPath.startsWith(p)
      );

      if (isInDashboard) {
        if (confirmingRef.current) {
          confirmingRef.current = false;
          clearTimeout(timerRef.current);
          setShowToast(false);
          App.exitApp();
        } else {
          confirmingRef.current = true;
          setShowToast(true);
          clearTimeout(timerRef.current);
          timerRef.current = setTimeout(() => {
            confirmingRef.current = false;
            setShowToast(false);
          }, 2000);
        }
      } else if (canGoBack) {
        window.history.back();
      } else {
        App.exitApp();
      }
    }).then(handle => {
      listenerHandle = handle;
    });

    return () => {
      clearTimeout(timerRef.current);
      listenerHandle?.remove();
    };
  }, []);

  if (!showToast) return null;

  return (
    <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-[9999] pointer-events-none">
      <div className="bg-gray-900/90 text-white text-sm font-semibold px-5 py-3 rounded-2xl shadow-2xl">
        Press back again to exit
      </div>
    </div>
  );
}
